import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nb-signin-not-admin',
  templateUrl: './signin-not-admin.component.html',
  styleUrls: ['./signin-not-admin.component.scss']
})
export class SigninNotAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
